import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';
import { CreateCertificate } from 'app/dtos/certificate/createCertificate';

@Injectable({
  providedIn: 'root'
})
export class CertificateService {

  constructor(private httpClientService:HttpClientService) { }

  async getLastCertificate(){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Certificate,
      action:"GetLastCertificate"
    });
    return await firstValueFrom(observable);
  }

  async gelAllCertificates(page,size,search){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Certificate,
      queryString:`Page=${page}&size=${size}&search=${search}`
    });
    return await firstValueFrom(observable);
  }

  async createCertificate(createCertificate:CreateCertificate){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.Certificate
    },
    {
      certificateNo:createCertificate.certificateNo,
      issueDate:createCertificate.issueDate,
      expiryDate:createCertificate.expiryDate,
      calibrationId:createCertificate.calibrationId,
      base64Data:createCertificate.base64Data
    });
    return await firstValueFrom(observable);
  }
}
